<!-- <div *ngIf="!orgRoleId" class="modal-header">
    <span class="modal-header-title">{{ 'USERS.USERS_ROLES.ADD_ROLE' | translate }}</span>
    <div class="tool">
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</div> -->

<div class="modal-body">

    <!-- <div class="row mb-3">
        <div class="col-12 mb-2">
            <span class="titel">{{ 'TEMPLATES.TEMPLATE' | translate }}</span>
        </div>
    </div> -->

    <!-- <div class="row mb-4 list-template">
        <div class="col-12 mb-2">
            <button class="btn btn-primary btn-sm template-titel mr-2 magenta" disabled="disabled" >Директор по продажам</button>
            <button class="btn btn-primary btn-sm template-titel mr-2 sunset-orange" disabled="disabled" >Адимнистратор</button>
            <button class="btn btn-primary btn-sm template-titel mr-2 polar-green" disabled="disabled" >Директор по маркетингу</button>
            <button class="btn btn-primary btn-sm template-titel geek-blue" disabled="disabled" >Менеджер продаж</button>
        </div>
    </div> -->

    <form class="form" [formGroup]="form" autocomplete="off">

        <div class="mb-3">
            <div class="row">
                <!-- <div class="col-6">
                    <ff-input-lang
                        class="ff-group" 
                        label="{{ 'USERS.USERS_ROLES.NAME_ROLE' | translate }}"
                        hint="{{ 'USERS.USERS_ROLES.NAME_ROLE_ALL_LANGUAGE' | translate }}"
                        fieldId="name" 
                        fieldName="name"
                        fieldType="text" 
                        [clearField]="ffInputLangParams.name.clearField"
                        [required]="ffInputLangParams.name.required" 
                        [inputValue]="roleName"
                        (changeValue)="eventFnFF('name', $event)">
                    </ff-input-lang>
                </div> -->
    
                <!-- <div class="col-6">

                    <div class="form-group">
                        <label for="label"><span class="star">*</span> {{ 'LABEL' | translate }}</label>
                        <input type="text" class="form-control" id="label" formControlName="label">
                        <div *ngIf="errorMessages">
                            <div *ngFor="let item of errorMessages.label">
                                <div class="text-error" *ngIf="validation('label', item.type)">
                                    {{ item.message | translate: item.options }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>

        <div class="row">

            <div class="col-12">

                <div class="row border-form-group">

                    <div class="col-6">

                        <div class="form-group border-form">
                            <label for="legal_form_id" class="card-header">
                                {{ 'USERS.USERS_ROLES.CHOOSE_MODULE' | translate }}
                                <svg-icon tooltipClass="clue-name" ngbTooltip="Обязательное для заполнения" src="/assets/images/icons/info-circle.svg" [stretch]="true"
                                [svgStyle]="{'width.px':15, 'height.px':15}"></svg-icon>
                            </label>
                                <ng-select 
                                    id="module_id" 
                                    class="custom" 
                                    clearAllText="{{ 'CLEAR' | translate }}" 
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                    [dropdownPosition]="'bottom'" 
                                    bindValue="id" 
                                    bindLabel="name"
                                    formControlName="module_id"
                                    placeholder="{{ 'DIALOG.TAG_LIST.NAME_MARK' | translate }}"
                                    [multiple]="true"
                                    [isOpen]="true"
                                    [loading]="loading" 
                                    [items]="modules">
                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        <input class="ng-placeholder" id="module-{{index}}" type="checkbox" [checked]="item$.selected" (click)="checkModuleState($event.target.checked, item.id)"/>&nbsp;
                                        <span>{{item.name}}</span>
                                </ng-template>
                                </ng-select>
                                <div *ngIf="errorMessages">
                                    <div *ngFor="let item of errorMessages.module_id">
                                        <div class="text-error" *ngIf="validation('module_id', item.type)">
                                            {{ item.message | translate: item.options }}
                                        </div>
                                    </div>
                                </div>
                        </div>
            
                    </div>
            
                    <div class="col-6">
            
                        <div class="form-group border-form">
                            <label for="legal_form_id" class="card-header">{{ 'PERMISSION' | translate }}
                                <svg-icon tooltipClass="clue-name" ngbTooltip="Обязательное для заполнения" src="/assets/images/icons/info-circle.svg" [stretch]="true"
                                [svgStyle]="{'width.px':15, 'height.px':15}"></svg-icon>
                            </label>
                            <!-- bindValue="permission_id" 
                            bindLabel="permission_name" -->
                                <ng-select 
                                    id="permission_id" 
                                    class="custom" 
                                    clearAllText="{{ 'CLEAR' | translate }}" 
                                    notFoundText="{{ 'NO_DATA' | translate }}"
                                   
                                    formControlName="permissions"
                                    placeholder="{{ 'CHOOSE_PERMISSION' | translate }}"
                                    groupBy="module_name"
                                    [multiple]="true"
                                    [loading]="loading"
                                    [selectableGroup]="true"
                                    [selectableGroupAsModel]="false" 
                                    [dropdownPosition]="'bottom'"
                                    [closeOnSelect]="false"
                                    [isOpen]="true"
                                    [items]="permissionsByModule">
                                
                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                            <input class="ng-placeholder" id="permission-{{index}}" type="checkbox" [checked]="item$.selected" />&nbsp;
                                            <span>{{item.permission_name}}</span>
                                    </ng-template>
                                </ng-select>
                                <div *ngIf="errorMessages">
                                    <div *ngFor="let item of errorMessages.permissions">
                                        <div class="text-error" *ngIf="validation('permissions', item.type)">
                                            {{ item.message | translate: item.options }}
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>

                </div>
                <div class="tools d-flex flex-end btn-pos">
                <!-- <button *ngIf="!orgRoleId" type="button" class="btn btn-primary btn-sm"  (click)="onCreate()"  [disabled]="form.invalid || !ffInputLang.valid">{{ 'SAVE'| translate}}</button>
                <button *ngIf="orgRoleId"  type="button" class="btn btn-primary btn-sm" (click)="onUpdate()" [disabled]="form.invalid || !ffInputLang.valid">{{ 'SAVE'| translate}}</button> -->
            </div>

            </div>

        </div>
        

        <!-- <div class="form-group">
                    <label for="legal_form_id"> {{ 'USERS.USERS_ROLES.CHOOSE_MODULE' | translate }}</label>
                    <ng-select 
                        id="module_id" 
                        class="custom"
                        clearAllText="{{ 'CLEAR' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}"
                        bindLabel="name"
                        bindValue="id"
                        formControlName="module_id"
                        placeholder="{{ 'DIALOG.TAG_LIST.NAME_MARK' | translate }}"
                        [multiple]="true"
                        [dropdownPosition]="'top'"
                        [loading]="loading"
                        [items]="modules">
                    </ng-select>
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.module_id">
                            <div class="text-error" *ngIf="validation('module_id', item.type)">
                                {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div> -->

        <!-- <div class="form-group">
                    <label for="legal_form_id"> {{ 'PERMISSION' | translate }}</label>
                    <ng-select 
                        id="permission_id"
                        class="custom"
                        clearAllText="{{ 'CLEAR' | translate }}"
                        notFoundText="{{ 'NO_DATA' | translate }}"
                        bindLabel="permission_name"
                        bindValue="permission_id"
                        formControlName="permissions"
                        placeholder="{{ 'CHOOSE_PERMISSION' | translate }}"
                        groupBy="module_name"
                        [dropdownPosition]="'bottom'"
                        [multiple]="true"
                        [loading]="loading"
                        [closeOnSelect]="false"
                        [items]="permissionsByModule">
                        <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                            <input id="item-{{index}}" type="checkbox" [checked]="item$.selected" />&nbsp;
                            <span>{{item.permission_name}}</span>
                        </ng-template>
                    </ng-select>
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.permissions">
                            <div class="text-error" *ngIf="validation('permissions', item.type)">
                                {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div> -->
    
    </form>

    <!-- <div class="col-12">

        <div class="row">

            <div class="col-6">

                <div class="card">

                    <div class="card-header">
                        <label for="legal_form_id"> {{ 'USERS.USERS_ROLES.CHOOSE_MODULE' | translate }}</label>
                    </div>
                    
                    <div class="card_body">
                        <div class="list">
                            <ul class="module-list">
                                <li *ngFor="let module of modules;let i = index">
                                    <input type="checkbox" [(ngModel)]="moduleCheckbox[i]" (change)="checkboxModuleEvent($event, module.id, i)">
                                    {{module.name}}      
                                </li>
                            </ul>
                        </div>
                    </div>

                </div>

            </div>
    
            <div class="col-6">

                <div class="card">

                    <div class="card-header">
                        <label for="legal_form_id"> {{ 'PERMISSION' | translate }}</label>
                    </div>

                    <div class="card_body">
                        <div class="list">
                            <div class="choose">
                                <li class="choose-all" for="select_all_permission">
                                    <input 
                                    class="mr-1 ml-1"
                                    type="checkbox"
                                    name="select_all_permission"
                                    [checked]="isAllCheckBoxChecked()"
                                    [indeterminate]="checkedButNotAllCheckBox()"
                                    (change)="checkAllCheckBox($event)">
                                        {{ 'INTEGRATION.SELECT_ALL' | translate }}
                                </li>
                            </div>
                            <ul class="permission-list">
                                <li *ngFor="let permission of permissionsByModule; let i = index">
                                    <input type="checkbox"
                                    [(ngModel)]="permissonCheckbox[i]"
                                    (change)="checkboxPermissonEvent(i, $event, permission.permission_id)">
                                    {{permission.permission_name}}
                                </li>
                            </ul>
                        </div>

                        popoverClass="my-custom-class" ngbPopover="{{ 'TO_ADD_ACCESS' | translate }}"
                        [openDelay]="300" [closeDelay]="1000" popoverTitle="{{ 'ATTENTION' | translate }}"
                    </div>

                </div>

            </div>

        </div>

    </div> -->

</div>
    <!-- <div class="row">
        <div class="col-12 mb-2">
            <div class="card">
                <div class="card-header">
                    <div class="input-group mb-3 serch-size">
                        <input type="text" class="form-control"
                            placeholder="{{ 'USERS.USERS_ROLES.NAME_ROLE' | translate }}" aria-label=""
                            aria-describedby="button-addon2">
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="button" id="button-addon2"><i
                                    class="bi bi bi-search"></i></button>
                        </div>
                    </div>
                </div>
                <div class="card-body">

                    <form class="form" [formGroup]="form" autocomplete="off">

                        <div class="row">
                
                            <div class="col-12 mb-2">
                                <ff-input-lang label="{{ 'USERS.USERS_ROLES.NAME_ROLE' | translate }}"
                                    hint="{{ 'USERS.USERS_ROLES.NAME_ROLE_ALL_LANGUAGE' | translate }}" fieldId="name" fieldName="name"
                                    fieldType="text" [clearField]="ffInputLangParams.name.clearField"
                                    [required]="ffInputLangParams.name.required" [inputValue]="roleName"
                                    (changeValue)="eventFnFF('name', $event)">
                                </ff-input-lang>
                            </div>
                
                            <div class="col-12 mb-2">
                
                                <div class="form-group">
                                    <label for="label"><span class="star">*</span> {{ 'LABEL' | translate }}</label>
                                    <input type="text" class="form-control" id="label" formControlName="label">
                                    <div *ngIf="errorMessages">
                                        <div *ngFor="let item of errorMessages.label">
                                            <div class="text-error" *ngIf="validation('label', item.type)">
                                                {{ item.message | translate: item.options }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                
                            </div>
                        </div>
                    </form>                    

                    <form class="form" [formGroup]="form" autocomplete="off">

                        <div class="col-12 mb-2 mb-4">

                            <div class="form-group">
                                <label for="legal_form_id"> {{ 'USERS.USERS_ROLES.CHOOSE_MODULE' | translate }}</label>
                                <ng-select id="module_id" class="custom" clearAllText="{{ 'CLEAR' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}" bindLabel="name" bindValue="id"
                                    formControlName="module_id"
                                    placeholder="{{ 'DIALOG.TAG_LIST.NAME_MARK' | translate }}" [multiple]="true"
                                    [dropdownPosition]="'top'" [loading]="loading" [items]="modules">
                                </ng-select>
                                <div *ngIf="errorMessages">
                                    <div *ngFor="let item of errorMessages.module_id">
                                        <div class="text-error" *ngIf="validation('module_id', item.type)">
                                            {{ item.message | translate: item.options }}
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="col-12 mb-2">

                            <div class="form-group">
                                <label for="legal_form_id"> {{ 'PERMISSION' | translate }}</label>
                                <ng-select id="permission_id" class="custom" clearAllText="{{ 'CLEAR' | translate }}"
                                    notFoundText="{{ 'NO_DATA' | translate }}" bindLabel="permission_name"
                                    bindValue="permission_id" formControlName="permissions"
                                    placeholder="{{ 'CHOOSE_PERMISSION' | translate }}" groupBy="module_name"
                                    [dropdownPosition]="'bottom'" [multiple]="true" [loading]="loading"
                                    [closeOnSelect]="false" [items]="permissionsByModule">
                                    <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                                        <input id="item-{{index}}" type="checkbox" [checked]="item$.selected" />&nbsp;
                                        <span>{{item.permission_name}}</span>
                                    </ng-template>
                                </ng-select>
                                <div *ngIf="errorMessages">
                                    <div *ngFor="let item of errorMessages.permissions">
                                        <div class="text-error" *ngIf="validation('permissions', item.type)">
                                            {{ item.message | translate: item.options }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </form>

                </div>
            
        </div>
    </div>
</div> -->
    <!-- <form class="form" [formGroup]="form" autocomplete="off">

        <div class="row">

            <div class="col-12 mb-2">
                <ff-input-lang
                    label="{{ 'USERS.USERS_ROLES.NAME_ROLE' | translate }}"
                    hint="{{ 'USERS.USERS_ROLES.NAME_ROLE_ALL_LANGUAGE' | translate }}"
                    fieldId="name"
                    fieldName="name"
                    fieldType="text"
                    [clearField]="ffInputLangParams.name.clearField"
                    [required]="ffInputLangParams.name.required"
                    [inputValue]="roleName"
                    (changeValue)="eventFnFF('name', $event)">
                </ff-input-lang>
            </div>

            <div class="col-12 mb-2">

                <div class="form-group">
                    <label for="label"><span class="star">*</span> {{ 'LABEL' | translate }}</label>
                    <input type="text" class="form-control" id="label" formControlName="label">
                    <div *ngIf="errorMessages">
                        <div *ngFor="let item of errorMessages.label">
                            <div class="text-error" *ngIf="validation('label', item.type)">
                                {{ item.message | translate: item.options }}
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>

    </form> -->
        <!-- <div *ngIf="!orgRoleId" class="modal-footer btn-box">
    <button type="button" class="btn btn-light btn-sm"   (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate}}</button>
    <button *ngIf="!orgRoleId" type="button" class="btn btn-primary btn-sm" (click)="onCreate()"     [disabled]="form.invalid || !ffInputLang.valid">{{ 'SAVE'| translate}}</button>
    <button *ngIf="orgRoleId"  type="button" class="btn btn-primary btn-sm" (click)="onUpdate()"     [disabled]="form.invalid || !ffInputLang.valid">{{ 'SAVE'| translate}}</button>
</div> -->